import {Component, Input, OnInit} from '@angular/core';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';

@Component({
  selector: 'lib-slider-item-more',
  templateUrl: './slider-item-more.component.html',
  styleUrls: ['./slider-item-more.component.scss']
})
export class SliderItemMoreComponent {

  @Input() title: string;
  @Input() colorScheme = ColorScheme.Dark;
  @Input() link?: string;
  @Input() routerLink?: string;
  @Input() small = false;

  constructor() { }
}
